<script setup>
import { computed, inject } from 'vue';

import { __ } from '@/utils'
import WhiteBox from '@components/whiteBox/whiteBox.vue';
import Grid from '@components/grid/grid.vue';
import Cellular from '@components/accountMain/parts/cellular.vue';
import ActionList from '@components/actionList/actionList.vue';
import InvoiceBox from '@components/accountMain/parts/invoice-box.vue';
import CourierBox from '@components/accountMain/parts/courier-box.vue';
import Tabs from '@components/tabs.vue';
import IconTabPhone from '@components/icons/icon-tab-phone.vue';
import AccountRoamingBanner from '@components/accountRoamingBanner/accountRoamingBanner.vue';
import Debt from '@components/debt/debt.vue';


const { features, details } = inject('account');

const tabs = [
	{
		title: __('cellular'),
        icon: IconTabPhone,
		body: [
			{ component: Cellular, props: {} },
		]
	},
    // {
	// 	title: 'internet',
    //     icon: IconTabInternet,
	// 	body: [
	// 		{ component: Cellular, props: {} },
	// 	]
	// },
    // {
	// 	title: 'international calls',
    //     icon: IconTabInternational,
	// 	body: [
	// 		{ component: Cellular, props: {} },
	// 	]
	// },
];

const first_name = computed(() => __('Hello') + ' ' + details.value.first_name);
</script>

<template>
    <div class="account-main">
        <h3 class="account-main__header">{{ first_name }}</h3>

        <Debt  v-if="details.collection_state" />

        <CourierBox v-if="features.tracking" />
    
        <Grid columns="2" gap="48" class="invoice-box-grid" v-if="features.messages && features.lastInvoice">
            <InvoiceBox />

            <WhiteBox :smaller="true" class="invoice-box invoice-box--alt" >
                <div class="invoice-box__content">
                    <h5>{{ __('Recent messages') }}</h5>
                    <p>{{ __('Lorem Ipsum Dolor Sit Emmett, Consector Adipiscing Alit Consector Adipiscing Alit. Seth Almancom nisi non prophesied. Des Iacolis Volupta...') }}</p>
                </div>
                <div class="invoice-box__actions">
                    <button type="button" class="link-icon"><img :src="`${theme_path.url}/resources/images/svg/icon-view.svg`" /> {{ __('viewing') }}</button>
                    <a href="#" class="link-underline">
                        {{ __('for all messages') }} 
                        <img :src="`${theme_path.url}/resources/images/svg/icon-arrow-left-bold.svg`" /> 
                    </a>
                </div>
                <div class="invoice-box__footer">
                    <p><img :src="`${theme_path.url}/resources/images/svg/icon-calendar.svg`" /> 4 ליולי 2023</p>
                </div>
            </WhiteBox>
        </Grid>
    
        <Tabs :tabs="tabs" class="tabs--line" />
 
        <ActionList />

        <AccountRoamingBanner />
    </div>
</template>